import { naturalLessThanFlag } from '@/_data/developmentFlags';
import type { NaturalLessThanFlag } from '@/_data/developmentFlags';
import type { AuthoredModeConfig, ModeConfig } from '@/workflow-runner/_contract/config';

export function assertAuthoredRunnerPresentation(config: Partial<AuthoredModeConfig> | undefined): void {
    const playback = config?.playback;
    if (!playback) return;
    for (const key of ['naturalLessThanPresentationMode', 'naturalLessThanPresentation']) {
        if (key in playback) throw new Error(`Flag-owned config field: adapterModeConfig.playback.${key}`);
    }
}

export function buildRunnerModeConfig(
    config: AuthoredModeConfig,
    flag: NaturalLessThanFlag = naturalLessThanFlag,
): ModeConfig {
    assertAuthoredRunnerPresentation(config);
    return { ...config, playback: { ...config.playback, naturalLessThanPresentationMode: flag } };
}
